var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"button toggle-preview-button",on:{"click":function($event){$event.preventDefault();return _vm.handleButtonClick.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.value ? 'Hide Preview' : 'Show Preview')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }